import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "filterable-contents-list list-page-body" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "list-page-sidebar-inner" }
const _hoisted_4 = {
  key: 0,
  class: "list-sidebar-section"
}
const _hoisted_5 = ["href", "data-turbo-frame", "data-turbo-action"]
const _hoisted_6 = { class: "list-sidebar-section" }
const _hoisted_7 = { class: "list-sidebar-title" }
const _hoisted_8 = { class: "contents-toolbar" }
const _hoisted_9 = { class: "contents-toolbar-inner" }
const _hoisted_10 = { class: "contents-filter" }
const _hoisted_11 = { class: "contents-filter-wrapper" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = {
  key: 0,
  class: "language-toggle"
}
const _hoisted_14 = ["href", "data-turbo-frame"]
const _hoisted_15 = { class: "contents-view-toggle" }
const _hoisted_16 = ["data-bs-title"]
const _hoisted_17 = ["data-bs-title"]
const _hoisted_18 = { class: "list-sidebar-section" }
const _hoisted_19 = { class: "list-sidebar-title" }
const _hoisted_20 = { class: "alphabet-nav alphabet-nav--vertical" }
const _hoisted_21 = ["href", "onClick"]
const _hoisted_22 = {
  key: 1,
  class: "alphabet-link disabled"
}
const _hoisted_23 = { class: "list-page-main" }
const _hoisted_24 = ["id", "data-letter"]
const _hoisted_25 = { class: "letter-heading" }
const _hoisted_26 = { class: "items-columns" }
const _hoisted_27 = ["href", "data-content-window-id", "data-content-window-title", "onClick"]
const _hoisted_28 = { class: "item-name" }
const _hoisted_29 = {
  key: 0,
  class: "bi bi-star-fill favorite-indicator"
}
const _hoisted_30 = {
  key: 0,
  class: "no-results"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", {
      class: "list-page-sidebar",
      "aria-label": $setup.label('sidebarNavigation', 'Navigation')
    }, [
      _createElementVNode("div", _hoisted_3, [
        ($props.backLink)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("a", {
                href: $props.backLink.url,
                class: "list-sidebar-link list-sidebar-back",
                "data-turbo-frame": $props.backLink.turboFrame || 'contents_browser',
                "data-turbo-action": $props.backLink.turboAction || 'advance'
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1 /* CACHED */)),
                _createTextVNode(" " + _toDisplayString($props.backLink.label), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_5)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h2", _hoisted_7, _toDisplayString($setup.label("filterTitle", "Filter")), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-search contents-filter-icon" }, null, -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.query) = $event)),
                    type: "text",
                    placeholder: $setup.label('filterPlaceholder', 'Filter items...'),
                    class: "contents-filter-input"
                  }, null, 8 /* PROPS */, _hoisted_12), [
                    [_vModelText, $setup.query]
                  ])
                ])
              ]),
              ($props.languageLinks.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.languageLinks, (link) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: link.code,
                        href: link.url,
                        class: _normalizeClass(["lang-btn", { active: link.active }]),
                        "data-turbo-frame": link.turboFrame || null
                      }, _toDisplayString(link.code), 11 /* TEXT, CLASS, PROPS */, _hoisted_14))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["view-btn", { active: $setup.viewMode === 'list' }]),
                  "data-bs-toggle": "tooltip",
                  "data-bs-title": $setup.label('viewList', 'List view'),
                  onClick: _cache[1] || (_cache[1] = $event => ($setup.setViewMode('list')))
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "bi bi-list" }, null, -1 /* CACHED */)
                ]))], 10 /* CLASS, PROPS */, _hoisted_16),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["view-btn", { active: $setup.viewMode === 'cards' }]),
                  "data-bs-toggle": "tooltip",
                  "data-bs-title": $setup.label('viewCards', 'Card view'),
                  onClick: _cache[2] || (_cache[2] = $event => ($setup.setViewMode('cards')))
                }, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("i", { class: "bi bi-grid-3x3-gap" }, null, -1 /* CACHED */)
                ]))], 10 /* CLASS, PROPS */, _hoisted_17)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("h2", _hoisted_19, _toDisplayString($setup.label("alphabetTitle", "A–Z")), 1 /* TEXT */),
          _createElementVNode("nav", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.letters, (letter) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: letter }, [
                ($setup.letterHasItems(letter))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: `#letter-${letter}`,
                      class: "alphabet-link",
                      onClick: $event => ($setup.jumpToLetter($event, letter))
                    }, _toDisplayString(letter), 9 /* TEXT, PROPS */, _hoisted_21))
                  : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(letter), 1 /* TEXT */))
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ], 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", {
        class: _normalizeClass($setup.listClass)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedGroups, ([letter, items]) => {
          return (_openBlock(), _createElementBlock("section", {
            id: `letter-${letter}`,
            key: letter,
            class: "letter-group",
            "data-letter": letter
          }, [
            _createElementVNode("h3", _hoisted_25, _toDisplayString(letter), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "content-item"
                }, [
                  _createElementVNode("a", {
                    href: item.url,
                    class: "item-link",
                    "data-turbo": "false",
                    "data-content-window-id": $props.openInWindow ? item.id : null,
                    "data-content-window-title": $props.openInWindow ? item.name : null,
                    onClick: $event => ($setup.openItem(item, $event))
                  }, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(item.name), 1 /* TEXT */),
                    (item.favorited)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_29))
                      : _createCommentVNode("v-if", true)
                  ], 8 /* PROPS */, _hoisted_27)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 8 /* PROPS */, _hoisted_24))
        }), 128 /* KEYED_FRAGMENT */)),
        ($setup.showNoResults)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _cache[7] || (_cache[7] = _createElementVNode("i", { class: "bi bi-search" }, null, -1 /* CACHED */)),
              _createElementVNode("p", null, _toDisplayString($setup.label("noResults", "No results found")), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ])
  ]))
}